const { objetos } = require('lib.front');

//const { execute, makePromise } = require('apollo-link');
//const { HttpLink } = require('apollo-link-http');
//const gql = require('graphql-tag');
//const fetch = require('node-fetch');

const clienteS = "000";


const esquemaCampos = {    
    codigo: { valor:clienteS, error: '' },
    tipoDoc: { valor: null, error: '' },
    nroDoc: { valor: '', error: '' },
    nombre: { valor: '', error: '' },
    apPaterno: { valor: '', error: '' },
    apMaterno: { valor: '', error: '' },
    razonSocial: { valor: '', error: '' },
    usuario: { valor: '', error: '' },
    pass: { valor: '', error: '' },
    pass2: { valor: '', error: '' },
    email: { valor: '', error: '' },
    telefono: { valor: '', error: '' },
    contacto: { valor: '', error: '' },
    observacion: { valor: '', error: '' },
    activo: { valor: '', error: '' }
}

const esquemaValidacion = {
    codigo: {
        requerido: true,
        validador: {
            regla: (valor) => {
                return valor !== ''
            }
        }
    },
    tipoDoc: {
        requerido: true,
        validador: {
            regla: (valor) => {
                return valor !== '' 
            }
        }
    },
    nroDoc: {
        requerido: true,
        validador: {
            regla: (valor) => {
                return valor !== '' 
            }
        }
    },
    nombre: {
        requerido: false
    },
    apPaterno: {
        requerido: false
    },
    apMaterno: {
        requerido: false
    },
    razonSocial: {
        requerido: false
    },
    usuario: {
        requerido: true,
        validador: {
            regla: (valor) => {
                return valor !== '' 
            }
        }
    },
    pass: {
        requerido: false,
        validador: {
            regla: (valor) => {
                return valor !== '' 
            }
        }
    },
    pass2: {
        requerido: false,
        validador: {
            regla: (valor, campos) => {
                return valor === campos.pass.valor;
            },
            error: 'El valor ingresado no concuerda con la clave anterior'
        }
    },
    email: {
        requerido: false,
        regla: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        error: 'El correo electronico no tiene un formato valido: [nombre]@[dominio].[etc]',
    },
    telefono: {
        requerido: false
    },
    contacto: {
        requerido: false
    },
    observacion: {
        requerido: false
    },
    activo: {
        requerido: false
    }
};

const esquemaQuery = [
    new objetos.oCampo('codigo', 'String!', true, true, true, true),
    new objetos.oCampo('tipoDoc', 'String!', true, false, true, true, 'tipoDoc{codigo descripcion}' ),
    new objetos.oCampo('nroDoc', 'String!', true, false, true, true),
    new objetos.oCampo('nombre', 'String', true, false, true, true),
    new objetos.oCampo('apPaterno', 'String', true, false, true, true),
    new objetos.oCampo('apMaterno', 'String', true, false, true, true),
    new objetos.oCampo('razonSocial', 'String', true, false, true, true),
    new objetos.oCampo('usuario', 'String!', true, false, true, true),
    new objetos.oCampo('pass', 'String', false, false, true, true),
    new objetos.oCampo('email', 'String', true, false, true, true),
    new objetos.oCampo('telefono', 'String', true, false, true, true),
    new objetos.oCampo('contacto', 'String', true, false, true, true),
    new objetos.oCampo('observacion', 'String', true, false, true, true),
    new objetos.oCampo('activo', 'Int', true, false, true, true)    
]

module.exports = { 
    esquemaCampos,
    esquemaValidacion,
    esquemaQuery,
    //liTipoDoc,
}